import {generateUniqueId} from "@/utils/general-utils";

export default class RequestSync {

  private lastId: string | null = null;

  constructor(private showLogs = false) {
  }

  public newRequest(): string {
    this.lastId = generateUniqueId();
    return this.lastId;
  }

  public isLastRequest(requestId: string): boolean {
    if (this.lastId !== requestId) {
      if (this.showLogs) {
        console.log("%c A previous request has arrived after a more recent one, the request was not taken into account", "color: red;");
        if (this.lastId === null) {
          console.warn('You need to call RequestSync.newRequest() before checking if the request is in sync');
        }
      }
      return false;
    }
    return true;
  }
}
